import { signalStore, withState, withMethods, patchState, withComputed } from '@ngrx/signals';
import { computed, inject } from '@angular/core';
import { ProgramGuidelinesService } from './program-guidelines.service';
import { EligibilityStatementRES } from '@program-suite/data-common';

interface ProgramGuidelinesState {
  eligibilityStatement?: EligibilityStatementRES | null;
}

const initialState: ProgramGuidelinesState = {
  eligibilityStatement: null,
};

export const ProgramGuidelinesStore = signalStore(
  { providedIn: 'root' },
  withState<ProgramGuidelinesState>(initialState),
  withComputed((state) => ({
    debug: computed(() => ({
      eligibilityStatement: state.eligibilityStatement,
    })),
  })),
  withMethods((store, programGuidelinesService = inject(ProgramGuidelinesService)) => ({
    setEligibilityStatement(eligibilityStatement: EligibilityStatementRES | null) {
      patchState(store, { eligibilityStatement });
    },
    async getEligibilityStatement(model: any) {
      const eligibilityStatement = await programGuidelinesService.getEligibilityStatement(model);
      this.setEligibilityStatement(eligibilityStatement);
    },
    reset() {
      patchState(store, initialState);
    },
  }))
);